import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ChevronDown = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 16C11.8401 16 11.6801 15.94 11.5501 15.8301L4.19251 9.04442C3.94259 8.81456 3.9326 8.42481 4.18252 8.18496C4.43244 7.94511 4.83231 7.93512 5.09222 8.17497L12 14.5409L18.9078 8.17497C19.1577 7.94511 19.5676 7.94511 19.8175 8.18496C20.0674 8.42481 20.0574 8.80457 19.8075 9.04442L12.4499 15.8201C12.3299 15.93 12.1599 15.99 12 15.99V16Z" />
  </svg>
)

export default withDefaultStyles(ChevronDown)
